import { render, staticRenderFns } from "./FeedlotDestination.vue?vue&type=template&id=2f7cd743"
import script from "./FeedlotDestination.vue?vue&type=script&lang=ts"
export * from "./FeedlotDestination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports